// extracted by mini-css-extract-plugin
module.exports = {"dropBtn":"PopoverDropdown_dropBtn__1NhjP","customBtn":"PopoverDropdown_customBtn__2Qqxa"};